import ForUserCard from './forUserCard';
import ForUser from '@/assets/website/for_user.png';
import ForOrg from '@/assets/website/for_org.png';
import { linkAfterCheckLogin, utilLogin } from '@/utils/checkLogin';
import { useNavigate } from 'react-router-dom';

export default function WhatIsVitae() {
  const navigate = useNavigate();
  const handleOrg = async () => {
    if (localStorage.getItem('token')) {
      if (localStorage.getItem('isInWhiteList') === 'true') {
        linkAfterCheckLogin('/manage/org/edit?type=new', navigate);
      } else {
        window.open('https://tally.so/r/3xXz4o');
      }
    } else {
      await utilLogin();
      window.location.reload();
    }
  };

  return (
    <div>
      <p className="mx-4 mb-14 mt-40 text-center text-3xl font-bold text-[#4e4e4e]">
        What is Vitae?
      </p>
      <div className="mx-10 flex flex-wrap justify-center">
        <ForUserCard
          src={ForOrg}
          forName="For Org"
          desc="Send Vitae as lifelong glory to verify member identity and experience to
        further encourage their engagement."
          buttonName="Create Org Space"
          onclick={() => handleOrg()}
        />
        <ForUserCard
          src={ForUser}
          forName="For User"
          desc="Claim the Vitae the Org sent you and it will preserve permanently, you can further build your Web3 profile."
          buttonName="Check My Profile"
          onclick={() => linkAfterCheckLogin('/profile', navigate)}
        />
      </div>
    </div>
  );
}
